import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { Button } from 'components/Forms'
import { Loading } from 'components/UI'
import { EventSummaryList } from 'components/Schedule'
import { Alert } from 'ui'

import { t } from 'translations'

const ScheduleFinalizeModal = ({ ids, isFinalizing }) => {
  const dispatch = useDispatch()
  const [isSubmitting, setIsSubmitting] = useState()
  const [events, setEvents] = useState()
  const [errorLoading, setErrorLoading] = useState(false)

  const type = isFinalizing ? 'FINALIZE' : 'UNFINALIZE'

  useEffect(() => {
    const fetchOldEvent = async () => {
      const { result, success } = await Api.post('schedule/schedule/query', { shiftIds: ids })
      if (!success || !result.length) return setErrorLoading(true)
      // We can only finalize shifts that have an employee assigned to them
      const eventsAssigned = result.filter(event => event.employeeId)
      // Filter the events depending if we are finalizing or not
      const filteredEvents = eventsAssigned.filter(event => (isFinalizing ? !event.finalized : event.finalized))
      setEvents(filteredEvents)
    }
    fetchOldEvent()
  }, [ids, isFinalizing])

  const finalize = async () => {
    setIsSubmitting(true)
    await Api.put('schedule/finalize', { shiftIds: events.map(({ _id }) => _id), finalize: isFinalizing })
    dispatch(closeModal())
  }

  if (!events && !errorLoading) return <Loading />

  return (
    <BaseModal hideButtons title={`manager.schedule.${type}`}>
      {errorLoading ? (
        <Alert variant="warning" className="mt-2">
          {t(`manager.schedule.${type}.ERROR_LOADING`)}
        </Alert>
      ) : (
        <>
          <Alert variant="warning" className="mt-2">
            {t(`manager.schedule.${type}.DESCRIPTION`)}
          </Alert>
          <EventSummaryList events={events} />
        </>
      )}

      <div className="mt-2">
        {errorLoading ? null : <Button text="actions.CONFIRM" isSubmitting={isSubmitting} className="btn btn-primary mr-2" onClick={() => finalize()} />}
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default ScheduleFinalizeModal
